import request from '@/utils/request'

export function GetArticle(id){
  return request({
    url: 'wx/article/'+id,
    method: 'get'
  })
}

export function GetArticleList(){
  return request({
    url: 'wx/article/home',
    method: 'get'
  })
}

export function GetArticleListByPaging(params){
  return request({
    url: 'wx/article',
    method: 'get',
    params
  })
}



// WEBPACK FOOTER //
// ./src/api/Article.js


// WEBPACK FOOTER //
// ./src/api/Article.js